// components/NotificationBell.jsx
//
// Shared header bell for customer and super-admin pages. Fetches the user's
// unread notification count on mount and refreshes it every 60 seconds, so
// every page with a header can link to the notification centre without
// duplicating the polling logic.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import useApiClient from "../hooks/useApiClient";
import styles from "./NotificationBell.module.css";

export default function NotificationBell({ className = "", title }) {
  const api = useApiClient();
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await api.getNotificationUnreadCount();
        if (!cancelled) setCount(res?.count || 0);
      } catch {
        // The bell is additive; a count failure must never break the header.
      }
    };

    load();
    const timer = setInterval(load, 60000);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  return (
    <Link
      to="/notifications"
      className={[styles.link, className].filter(Boolean).join(" ")}
      aria-label={
        count > 0
          ? `Notification centre, ${count} unread`
          : "Notification centre"
      }
      title={title || "Notification centre"}
    >
      <Bell size={17} />
      {count > 0 && (
        <span className={styles.badge}>
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
}
